import request from "@/utils/request.js"



export default {
    /**
     * 商机管理接口
     */
    demand: {
        list: params => request.post("/api/Job/Demand/GetList", params),
        info: params => request.post("/api/Job/Demand/GetInfo", params),
        submit: params => request.post("/api/Job/Demand/Submit", params),
        grab: params => request.get("/api/Job/Demand/Grabbing", { params }),
        quit: params => request.get("/api/Job/Demand/Quitting", { params }),
        progress: params => request.post("/api/Job/Demand/Progress", params),
        team: {
            list: params => request.get("/api/Job/Demand/Team/GetList", { params }),
            invite: params => request.post("/api/Job/Demand/Team/Invite", params),
            remove: params => request.post("/api/Job/Demand/Team/Remove", params)
        },
        statis: {
            states: params => request.post("/api/Job/Demand/Statis/States", params),
            users: params => request.post("/api/Job/Demand/Statis/Users", params),
        }
    },
    /**
     * 工作日程
     */
    schedule: {
        list: params => request.post("/api/Job/Schedule/GetList", params),
        info: params => request.post("/api/Job/Schedule/GetInfo", params),
        create: params => request.post("/api/Job/Schedule/Create", params),
        complete: params => request.post("/api/Job/Schedule/Complete", params),
        cancel: params => request.post("/api/Job/Schedule/Cancel", params),
        statis: {
            type: params => request.post("/api/Job/Schedule/GroupType", params),
        }
    },
    /**
     * 工作总结
     */
    report: {
        list: params => request.post("/api/Job/Report/GetList", params),
        info: params => request.post("/api/Job/Report/GetInfo", params),
        submit: params => request.post("/api/Job/Report/Submit", params),
        appraise: params => request.post("/api/Job/Report/Appraise", params),
        delete: params => request.post("/api/Job/Report/Delete", params),
        summary: params => request.post("/api/Job/Report/Summary", params),
    }
}